import React from 'react';
import styled from 'styled-components';

const Container = styled.div``;
const Label = styled.div`
  font-size: 9px;
`;
const Text = styled.div`
  font-size: 16px;
  margin-top: 0;
  padding-top: 0;
  margin-left: 5px;
  border-bottom: thin solid #e3e3e3;
`;

export default function LabelFiter(props) {
  const { text, label } = props;

  return (
    <Container>
      <Label> {label} </Label>
      <Text> {text} </Text>
    </Container>
  );
}
